import { invokeApi } from ".";
import * as endPoints from "../constants/ApiEndpoints";
import { APICall } from "../helpers/API/APICalls";
import { getFromEncLocalStorage } from "../helpers/Utils/Utils";

export const getBookmarks = async (reqBody) => {
  const token = await getFromEncLocalStorage("token");

  const data = await invokeApi(endPoints.getBookmarksApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    payload: reqBody,
  });

  return data;
};

export const updateBookmarks = async (bookmarkData) => {
  const token = await getFromEncLocalStorage("token");
  const data = await invokeApi(endPoints.updateBookmarksApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    payload: bookmarkData,
  });

  return data;
};

export const getAllBookmarks = async (reqBody) => {
  const data = await APICall(endPoints.getAllBookmarks, reqBody);
  return data;
};

const BookmarksService = { getBookmarks, updateBookmarks, getAllBookmarks };
export default BookmarksService;
